import React from 'react';
import PropTypes from 'prop-types';
import Title from '../../common/Title';

export default class AboutSection extends React.Component {

  get title() {
    return `About ${this.props.fullName.split(" ")[0]}`;
  }

  get biography() {
    const { biography } = this.props;
    return biography ? <p>{this.props.biography}</p> : null;
  }

  get overview() {
    const { overview } = this.props;
    return overview ? <p>{this.props.overview}</p> : null;
  }

  render() {
    return (
      <div>
        <Title text={this.title} />
        <div>
          {this.biography}
          {this.overview}
        </div>
      </div>
    );
  }
}

AboutSection.propTypes = {
  fullName: PropTypes.string.isRequired,
  biography: PropTypes.string,
  overview: PropTypes.string,
};
